export const MOBILISER_ADVANCED_MAPPING_FEATURE = "mobiliser-advanced-mapping-type-review"
export const MOBILISER_ADVANCED_MAPPING_FLAG = `feature-${MOBILISER_ADVANCED_MAPPING_FEATURE}`
